import { ImageComponent } from '@/types/components'

export const Image = ({ id, src, style }: Omit<ImageComponent, 'componentType'>) => {
  return <img id={id} src={src} className={`mx-auto h-14`} style={style} />
}
